import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20428b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gradient-editor" }
const _hoisted_2 = { class: "dialog-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" }, null, -1))
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "dialog-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1))
const _hoisted_8 = { class: "editor-top" }
const _hoisted_9 = { style: {"flex":"1"} }
const _hoisted_10 = {
  key: 0,
  class: "error-text"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-h" }, null, -1))
const _hoisted_12 = ["onMousedown", "onDblclick"]
const _hoisted_13 = ["onMousedown", "onDblclick"]
const _hoisted_14 = { class: "gradient-list" }
const _hoisted_15 = { class: "gradient-list-top" }
const _hoisted_16 = { class: "gradient-list-actions" }
const _hoisted_17 = { class: "gradient-list-action" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "gradient-list-list"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "gradient-inputs" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "gradient-list-list"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "gradient-inputs" }
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_menu = _resolveComponent("imdex-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_imdex_dialog, {
      dismissable: false,
      width: "430",
      value: _ctx.deleteGradientDialog,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteGradientDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          class: "dialog-card dialog-error"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.deleteGradient")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.confirmDelete")), 1),
            _hoisted_5,
            _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.permDelete")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_imdex_btn, {
              disabled: _ctx.deleteGradientLoading,
              text: "",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.deleteGradientDialog = false), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.closeBtn")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_imdex_btn, {
              secondary: "",
              dark: "",
              onClick: _ctx.deleteGradient,
              loading: _ctx.deleteGradientLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.deleteGradient")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _hoisted_7
        ], 32)
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_Transition, {
      "enter-active-class": "fadeInUp",
      "leave-active-class": "fadeOutDown"
    }, {
      default: _withCtx(() => [
        (_ctx.colorPickerOpen)
          ? (_openBlock(), _createBlock(_component_ColorPicker, {
              key: 0,
              color: _ctx.activeColor,
              onChange: _ctx.pickColor,
              ref: "colorPicker",
              forceColorUpdate: true
            }, null, 8, ["color", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_imdex_text_field, {
          label: _ctx.$t(`ssa.displayPane.colorGeneral.nameInput`),
          small: "",
          value: _ctx.gradientName,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gradientName) = $event))
        }, null, 8, ["label", "value"]),
        (_ctx.errorMessage != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_imdex_menu, {
        value: _ctx.showOptionsMenu,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showOptionsMenu) = $event))
      }, {
        template: _withCtx(() => [
          _createVNode(_component_imdex_btn, {
            icon: "",
            fab: "",
            compact: "",
            text: "",
            secondary: ""
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        dropdown: _withCtx(() => [
          _createElementVNode("div", {
            onMousedown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
            class: "folder-options-menu animated-fast"
          }, [
            _createElementVNode("ul", {
              onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("li", {
                style: {"white-space":"nowrap"},
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveGradient && _ctx.saveGradient(...args)))
              }, _toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.saveBtn`)) + " " + _toDisplayString(_ctx.isDefaultGradient
										? _ctx.$t(`ssa.displayPane.colorGeneral.asNew`)
										: "") + _toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.gradient`)), 33),
              _createElementVNode("li", {
                class: _normalizeClass({
									disabled: _ctx.isDefaultGradient || _ctx.isSelected(_ctx.gradientItem.id)
								}),
                style: {"white-space":"nowrap"},
                onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteGradientDialog = true))
              }, _toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.deleteGradient")), 35)
            ], 32)
          ], 32)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", {
      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.pickStop && _ctx.pickStop(...args))),
      class: "gradient-example",
      ref: "gradientBar",
      style: _normalizeStyle(`background:${_ctx.gradientScheme}`)
    }, [
      (!_ctx.isFixed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
            class: "gradient-blocks"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradient, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onMousedown: ($event: any) => ((_ctx.activeGradientItem = item.id), _ctx.startDrag($event)),
                class: _normalizeClass(["gradient-block", { active: _ctx.activeGradientItem == item.id }]),
                onDblclick: ($event: any) => (_ctx.openColorPicker(item.id, true)),
                key: i,
                ref_for: true,
                ref: `block-${item.id}`,
                style: _normalizeStyle(`background:${item.color}; left:${
						((item.stop - _ctx.range[0]) / (_ctx.range[1] - _ctx.range[0])) * 100
					}%;`)
              }, null, 46, _hoisted_12))
            }), 128))
          ], 32))
        : _createCommentVNode("", true),
      (_ctx.isFixed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onMousedown: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
            class: "gradient-blocks"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixedGradient, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onMousedown: ($event: any) => ((_ctx.activeGradientItem = item.minId), _ctx.startDrag($event)),
                class: _normalizeClass(["gradient-block", { active: _ctx.activeGradientItem == item.minId }]),
                onDblclick: ($event: any) => (_ctx.openColorPicker(item.minId, true)),
                key: i,
                ref_for: true,
                ref: `block-${item.minId}`,
                style: _normalizeStyle(`background:${item.color}; left:${
						_ctx.gradient.findIndex((item2) => item2.id == item.minId) == 0
							? 0
							: ((item.min - _ctx.range[0]) / (_ctx.range[1] - _ctx.range[0])) * 100
					}%;`)
              }, null, 46, _hoisted_13))
            }), 128))
          ], 32))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createTextVNode(_toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.colors`)) + " ", 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_imdex_btn, {
              disabled: _ctx.activeColor == null,
              compact: "",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addColorStop())),
              small: "",
              text: "",
              secondary: ""
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.add`)), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      (!_ctx.isFixed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradient, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "gradient-list-item",
                key: i
              }, [
                _createElementVNode("div", {
                  ref_for: true,
                  ref: item.id,
                  onClick: ($event: any) => ((_ctx.activeGradientItem = item.id), _ctx.openColorPicker(item.id)),
                  class: _normalizeClass([{ active: _ctx.activeGradientItem == item.id }, "gradient-color-square"]),
                  style: _normalizeStyle(`background:${item.color}`)
                }, null, 14, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_imdex_text_field, {
                    small: "",
                    value: item.color,
                    "onUpdate:value": ($event: any) => ((item.color) = $event)
                  }, null, 8, ["value", "onUpdate:value"]),
                  _createVNode(_component_imdex_text_field, {
                    small: "",
                    value: item.stop,
                    onChange: ($event: any) => (_ctx.changeStop(item, $event)),
                    type: "number"
                  }, null, 8, ["value", "onChange"])
                ]),
                (_ctx.gradient.length > 2)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.removeColorStop(item.id)),
                      class: "fal fa-times"
                    }, null, 8, _hoisted_22))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFixed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixedGradient, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "gradient-list-item",
                key: i
              }, [
                _createElementVNode("div", {
                  ref_for: true,
                  ref: item.minId,
                  onClick: ($event: any) => ((_ctx.activeGradientItem = item.minId), _ctx.openColorPicker(item.minId)),
                  class: _normalizeClass([{ active: _ctx.activeGradientItem == item.minId }, "gradient-color-square"]),
                  style: _normalizeStyle(`background:${item.color}`)
                }, null, 14, _hoisted_24),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_imdex_text_field, {
                    small: "",
                    value: item.min,
                    onChange: ($event: any) => (_ctx.changeStop(item, $event)),
                    label: _ctx.$t('ssa.displayPane.min'),
                    type: "number"
                  }, null, 8, ["value", "onChange", "label"]),
                  _createVNode(_component_imdex_text_field, {
                    small: "",
                    label: _ctx.$t('ssa.displayPane.max'),
                    value: item.max,
                    onChange: ($event: any) => (_ctx.changeStop(item, $event, true)),
                    type: "number"
                  }, null, 8, ["label", "value", "onChange"]),
                  _createVNode(_component_imdex_text_field, {
                    small: "",
                    value: 
								_ctx.gradient[_ctx.gradient.findIndex((item2) => item2.id == item.minId)]
									.annotation
							,
                    "onUpdate:value": ($event: any) => ((
								_ctx.gradient[_ctx.gradient.findIndex((item2) => item2.id == item.minId)]
									.annotation
							) = $event),
                    label: _ctx.$t('ssa.displayPane.colorGeneral.label'),
                    type: "text"
                  }, null, 8, ["value", "onUpdate:value", "label"])
                ]),
                (_ctx.gradient.length > 4)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.removeColorStop(item.minId)),
                      class: "fal fa-times"
                    }, null, 8, _hoisted_26))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}